import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ICustomerWalletCategory } from '../../interfaces/customer-wallet.interface';

@Component({
    selector: 'customer-wallet-category-chips',
    templateUrl: './category-chips.component.html',
    styleUrls: ['./category-chips.component.scss'],
})
export class CustomerWalletCategoryChipsComponent implements OnChanges {

    public categoriesChips = {
        selected: 0,
        items: [],
    };

    @Input()
    public categories: ICustomerWalletCategory[];

    @Input()
    public selected: string;

    @Output()
    public onSelect = new EventEmitter<ICustomerWalletCategory>();

    @Input()
    public title: string = 'Classes Estratégicas';

    @Input()
    public useTitle: boolean = true;

    public ngOnChanges({ selected, categories }: SimpleChanges): void {
        if (categories) {
            this.categoriesChips.items = categories.currentValue.map(({ name: label, slug: value }, id) => ({
                id,
                label,
                value,
            }));
        }

        if (selected || categories) {
            this.categoriesChips.selected = Math.max(
                this.categories.findIndex(({ slug }) => slug === this.selected),
                0,
            );
        }

    }

    public onSelectChip({ value: { value } }) {
        const category = this.categories.find(({ slug }) => slug == value);
        if (category) {
            this.selected = category.slug;
            this.onSelect.emit(category);
        }
    }

}